const DEALER_DESKTOP_MIN_WIDTH = 1400;
export const isNavbarExpandable = (): boolean => window.innerWidth >= DEALER_DESKTOP_MIN_WIDTH;
